import type { HierarchyItem, HierarchyItemWithLevels } from '@openx/types/hierarchyItem.ts';
import { type JSX, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { filterWithParents } from '../utils/filterWithParents.ts';
import { flattenWithLevels } from '../utils/flattenWithLevels.ts';

export const useHierarchyData = (
  data: HierarchyItem[],
  searchPhrase: string,
  isLoading: boolean,
  noOptionsText: () => JSX.Element
) => {
  const { t } = useTranslation();

  const inventories: HierarchyItemWithLevels[] = useMemo(() => flattenWithLevels(data) ?? [], [data]);

  const filterOptions = useCallback(
    (options: HierarchyItemWithLevels[]) => {
      if (searchPhrase.length < 3) {
        return [];
      }

      return filterWithParents(options, searchPhrase);
    },
    [searchPhrase]
  );

  const getNoOptionsText = useCallback(() => {
    if (!searchPhrase || searchPhrase.length < 3 || isLoading) {
      return t('Type at least 3 characters in order to search');
    }
    return noOptionsText();
  }, [searchPhrase, isLoading, t, noOptionsText]);

  return {
    inventories,
    filterOptions,
    getNoOptionsText,
  };
};
